import { EventsService } from 'src/app/services/events.service';
import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styles: [],
})
export class SidebarComponent implements OnInit {
    constructor(public sharedService: SharedService, private eventsService: EventsService) {}

    ngOnInit(): void {}

    toggleSideBar() {
        this.sharedService.sidebarOpen = !this.sharedService.sidebarOpen;
        this.sharedService.setState();
    }

    toggleSideBarItem(item: any, pop: any) {
        if (this.sharedService.sidebarOpen) {
            item.isOpen = !item.isOpen;
        } else {
            item.isOpenMobile = !item.isOpenMobile;
            pop.toggle();
        }

        this.closeAllMobile(true, item);
        this.sharedService.setState();
    }

    onClickedOutside() {
        this.closeAllMobile();
    }

    closeAllMobile(except?: boolean, item?: any) {
        this.sharedService.sidebarItems.forEach((element) => {
            if (except) {
                if (element !== item) {
                    element.isOpenMobile = false;
                }
            } else {
                element.isOpenMobile = false;
            }
        });
    }

    onClickedOutsideSideBar() {
        if (window.innerWidth <= 768) {
            if (this.sharedService.sidebarOpen) {
                this.sharedService.sidebarOpen = false;
                this.sharedService.setState();
            }
        }
    }

    closeAllPops(pop: any) {
        pop.close();
        this.closeAllMobile();
    }
}
